// File-upload categories. Used by every upload UI that has a Category dropdown.
export const FILE_CATEGORIES = [
  "Translatable",
  "Reference",
  "Translation Memory (TM)",
  "Glossary / Termbase",
  "Style Guide",
  "Others",
];
